import { render, staticRenderFns } from "./LAlert.vue?vue&type=template&id=512109c5&"
import script from "./LAlert.vue?vue&type=script&lang=js&"
export * from "./LAlert.vue?vue&type=script&lang=js&"
import style0 from "./LAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports